import React from 'react';
import classNames from 'classnames';
import CodeSparkThemedTypography from '../../../../../components/elements/CodeSparkThemedTypography';
import { ValuePropIcon } from '../../../../../components/elements/ValuePropsList';
import styles from './PlanSelectorV4.module.css';

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/global`;

const ValueProp = ({ icon, srLabel }) => {
  return (
    <>
      <ValuePropIcon size="medium" icon={icon} className={styles.valuePropIcon} />
      <CodeSparkThemedTypography variant="srOnly">{srLabel}</CodeSparkThemedTypography>
    </>
  );
};

const IncludedIcon = () => (
  <ValueProp icon={`${imgURL}/checkmark-updated-blue.svg`} srLabel="Included" />
);

const NotIncludedIcon = () => (
  <ValueProp icon={`${imgURL}/minus-gray.svg`} srLabel="Not included" />
);

const DisplayIcon = ({ isIncluded }) => {
  return isIncluded ? <IncludedIcon /> : <NotIncludedIcon />;
};

export default function PlanComparison({ valueProps, planOptionsData }) {
  const leftSidePlan = planOptionsData[0];
  const rightSidePlan = planOptionsData[1];
  const missingComparisonValues =
    !leftSidePlan ||
    !leftSidePlan.valuePropsMapping ||
    !rightSidePlan ||
    !rightSidePlan.valuePropsMapping;

  if (missingComparisonValues) {
    return null;
  }

  return (
    <div className={styles.planComparison}>
      {valueProps.map(({ key, text }, i) => {
        const isLeftPlanChecked = leftSidePlan.valuePropsMapping[key];
        const isRightPlanChecked = rightSidePlan.valuePropsMapping[key];

        return (
          <div key={key} className={styles.planComparisonRow}>
            <div className={styles.planComparisonRowIcon}>
              <DisplayIcon isIncluded={isLeftPlanChecked} />
            </div>
            <div className={styles.planComparisonRowValueProp}>
              <CodeSparkThemedTypography
                variant="body2"
                className={styles.planComparisonRowValuePropText}
              >
                {text}
              </CodeSparkThemedTypography>
            </div>
            <div className={styles.planComparisonRowIcon}>
              <DisplayIcon isIncluded={isRightPlanChecked} />
            </div>
          </div>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/V4/PlanComparison.js